import React, { useEffect, useState } from "react"
import { Bar } from "react-chartjs-2"
import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { useLazyGetWealtDashboardPayableAmountChartQuery } from "store/api/wealthpartnerapi/wealthReport"

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const CommissionEarnedChart = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [filters, setFilters] = useState({ period: "This Year" })
  const [data, setData] = useState(null)

  const [getResults, { isFetching }] =
    useLazyGetWealtDashboardPayableAmountChartQuery()

  const getList = async () => {
    try {
      const { data } = await getResults({ ...filters }).unwrap()
      setData(data)
    } catch (e) {
      console.error("Error fetching chart data", e)
    }
  }
  useEffect(() => {
    getList()
  }, [filters])

  const options = {
    responsive: true,

    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#000",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        displayColors: false,
        callbacks: {
          label: (context) => `₹${context.parsed.y.toLocaleString()}`,
          title: () => "Earnings",
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#3b3b3b", font: { size: 12 } },
      },
      y: {
        grid: {
          color: "#e5e5e5",
          borderDash: [2, 4],
          borderWidth: 1,
          drawTicks: false,
        },
        ticks: { display: false },
        border: { display: false },
      },
    },
  }

  return (
    <>
      <div className="chart-top-section-wrapper wealth-patner">
        <h2>Commission Payable</h2>

        <div className="dropdown-section">
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle caret size="lg">
              {filters.period} <img src={downArrowIcon} alt="" />
            </DropdownToggle>
            <DropdownMenu style={{ minWidth: "auto" }}>
              {periods.map((item, index) => (
                <DropdownItem
                  key={`periods_${index}`}
                  onClick={() => setFilters({ period: item })}
                >
                  {item}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div style={{ width: "100%", maxWidth: "100%" }}>
        {data && <Bar data={data} options={options} />}
      </div>
    </>
  )
}

export default CommissionEarnedChart
